import type { TranslationMessages } from '../types';

export const menu: TranslationMessages = {
  sales: 'Sales',
  catalog: 'Products',
  customers: 'Customers',
  library: 'Library',
  memberships: 'Memberships',
  staff: 'Staff Management',
  staff_profiles: 'Staff Profiles',
  organization: 'Organization',
  financial: 'Financial Management',
  system: 'System',
  zalo: 'Zalo Integration',
};
